import React from 'react'

import PropertyTypeList from '../components/PropertyType/PropertyTypeList'

const PropertyTypePage = () => {
    return (
        <PropertyTypeList />
    )
}

export default PropertyTypePage